/* eslint-disable */
import Long from 'long';
import _m0 from 'protobufjs/minimal';

export const protobufPackage = 'com.celertech.staticdata.api.account.property';

export interface AccountPropertyDownstreamEvent {
    id: string;
    code: string;
    key: string;
    value: string;
    description: string;
    createdTimestampUtcInMillis: string;
    updatedTimestampUtcInMillis: string;
}

export interface DeleteAccountPropertyNotification {
    id: string;
    code: string;
    key: string;
    value: string;
    description: string;
    createdTimestampUtcInMillis: string;
    updatedTimestampUtcInMillis: string;
}

function createBaseAccountPropertyDownstreamEvent(): AccountPropertyDownstreamEvent {
    return {
        id: '0',
        code: '',
        key: '',
        value: '',
        description: '',
        createdTimestampUtcInMillis: '0',
        updatedTimestampUtcInMillis: '0'
    };
}

export const AccountPropertyDownstreamEvent = {
    encode(message: AccountPropertyDownstreamEvent, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
        if (message.id !== '0') {
            writer.uint32(8).int64(message.id);
        }
        if (message.code !== '') {
            writer.uint32(18).string(message.code);
        }
        if (message.key !== '') {
            writer.uint32(26).string(message.key);
        }
        if (message.value !== '') {
            writer.uint32(34).string(message.value);
        }
        if (message.description !== '') {
            writer.uint32(42).string(message.description);
        }
        if (message.createdTimestampUtcInMillis !== '0') {
            writer.uint32(48).int64(message.createdTimestampUtcInMillis);
        }
        if (message.updatedTimestampUtcInMillis !== '0') {
            writer.uint32(56).int64(message.updatedTimestampUtcInMillis);
        }
        return writer;
    },

    decode(input: _m0.Reader | Uint8Array, length?: number): AccountPropertyDownstreamEvent {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAccountPropertyDownstreamEvent();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.id = longToString(reader.int64() as Long);
                    break;
                case 2:
                    message.code = reader.string();
                    break;
                case 3:
                    message.key = reader.string();
                    break;
                case 4:
                    message.value = reader.string();
                    break;
                case 5:
                    message.description = reader.string();
                    break;
                case 6:
                    message.createdTimestampUtcInMillis = longToString(reader.int64() as Long);
                    break;
                case 7:
                    message.updatedTimestampUtcInMillis = longToString(reader.int64() as Long);
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },

    fromPartial(object: DeepPartial<AccountPropertyDownstreamEvent>): AccountPropertyDownstreamEvent {
        const message = createBaseAccountPropertyDownstreamEvent();
        message.id = object.id ?? '0';
        message.code = object.code ?? '';
        message.key = object.key ?? '';
        message.value = object.value ?? '';
        message.description = object.description ?? '';
        message.createdTimestampUtcInMillis = object.createdTimestampUtcInMillis ?? '0';
        message.updatedTimestampUtcInMillis = object.updatedTimestampUtcInMillis ?? '0';
        return message;
    }
};

function createBaseDeleteAccountPropertyNotification(): DeleteAccountPropertyNotification {
    return {
        id: '0',
        code: '',
        key: '',
        value: '',
        description: '',
        createdTimestampUtcInMillis: '0',
        updatedTimestampUtcInMillis: '0'
    };
}

export const DeleteAccountPropertyNotification = {
    encode(message: DeleteAccountPropertyNotification, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
        if (message.id !== '0') {
            writer.uint32(8).int64(message.id);
        }
        if (message.code !== '') {
            writer.uint32(18).string(message.code);
        }
        if (message.key !== '') {
            writer.uint32(26).string(message.key);
        }
        if (message.value !== '') {
            writer.uint32(34).string(message.value);
        }
        if (message.description !== '') {
            writer.uint32(42).string(message.description);
        }
        if (message.createdTimestampUtcInMillis !== '0') {
            writer.uint32(48).int64(message.createdTimestampUtcInMillis);
        }
        if (message.updatedTimestampUtcInMillis !== '0') {
            writer.uint32(56).int64(message.updatedTimestampUtcInMillis);
        }
        return writer;
    },

    decode(input: _m0.Reader | Uint8Array, length?: number): DeleteAccountPropertyNotification {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDeleteAccountPropertyNotification();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.id = longToString(reader.int64() as Long);
                    break;
                case 2:
                    message.code = reader.string();
                    break;
                case 3:
                    message.key = reader.string();
                    break;
                case 4:
                    message.value = reader.string();
                    break;
                case 5:
                    message.description = reader.string();
                    break;
                case 6:
                    message.createdTimestampUtcInMillis = longToString(reader.int64() as Long);
                    break;
                case 7:
                    message.updatedTimestampUtcInMillis = longToString(reader.int64() as Long);
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },

    fromPartial(object: DeepPartial<DeleteAccountPropertyNotification>): DeleteAccountPropertyNotification {
        const message = createBaseDeleteAccountPropertyNotification();
        message.id = object.id ?? '0';
        message.code = object.code ?? '';
        message.key = object.key ?? '';
        message.value = object.value ?? '';
        message.description = object.description ?? '';
        message.createdTimestampUtcInMillis = object.createdTimestampUtcInMillis ?? '0';
        message.updatedTimestampUtcInMillis = object.updatedTimestampUtcInMillis ?? '0';
        return message;
    }
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin
    ? T
    : T extends Array<infer U>
    ? Array<DeepPartial<U>>
    : T extends ReadonlyArray<infer U>
    ? ReadonlyArray<DeepPartial<U>>
    : T extends {}
    ? { [K in keyof T]?: DeepPartial<T[K]> }
    : Partial<T>;

function longToString(long: Long) {
    return long.toString();
}

if (_m0.util.Long !== Long) {
    _m0.util.Long = Long as any;
    _m0.configure();
}
